import { Component, input, InputSignal } from '@angular/core';
import { Icon, IconType } from '../icon/icon';

@Component({
  selector: 'app-stepper-circle-progress',
  imports: [Icon],
  template: `
    @if (stepIndex()) {
      <span>{{ stepIndex() }}</span>
    }
    <app-icon color="#ffffff" [icon]="icon()" class="icon" />
  `,
  styleUrl: './stepper-circle-progress.scss',
  host: {
    '[style.--completionPercent]': 'completionPercent()',
    '[style.--stepIndex]': 'stepIndex() - 1',
  },
})
export class StepperCircleProgress {
  icon: InputSignal<IconType> = input.required();
  stepIndex: InputSignal<number> = input(0);
  completionPercent: InputSignal<number> = input<number>(0);
}
